import React, { useMemo } from 'react'
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom'
import { makeStyles, createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles'
import CssBaseline from '@material-ui/core/CssBaseline'

import paletteDark from './theme/paletteDark'
import typography from './theme/typography'

import arms from '../game-data/arms.json'
import slots from '../game-data/slots.json'
import boons from '../game-data/boons.json'

import { AppContext } from './context'

import Builder from './builder'


const useStyles = makeStyles((theme) => ({
  '@global': {
    html: {
      height: '100%',
      width: '100%',
      fontSize: '10px'
    },
    body: {
      height: '100%',
      width: '100%',
      '& > div': {
        height: '100%',
        width: '100%'
      }
    }
  },
  root: {
    height: '100%',
    width: '100%',
    margin: '0px',
    padding: '0px',
    fontFamily: 'Noto Sans, sans-serif',
  },
  mainContent: {
    width: '100%',
    [theme.breakpoints.up('md')]: { padding: '20px 45px 0px 45px' },
    [theme.breakpoints.down('md')]: { overflowY: 'auto', height: '100%' },
  }
}))

const App = () => {
  const classes = useStyles()

  const theme = useMemo(
    () =>
      createMuiTheme({
        // TODO: fallback logic
        padding: '5px',
        margin: '5px',
        typography,
        palette: paletteDark,
      }),
    []
  )

  return (
    <Router>
      <MuiThemeProvider theme={theme}>
        <div className={classes.root}>
          <CssBaseline />
          <AppContext.Provider value={{ arms, slots, boons }}>
            <div className={classes.mainContent}>
              <Switch>
                <Route exact path='/' component={Builder} />
              </Switch>
            </div>
          </AppContext.Provider>
        </div>
      </MuiThemeProvider>
    </Router>
  )
}

export default App
